import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DefaultButton, FormButtonBack, FormInput } from 'shared/ui';
import { validatePasswordChangeForm } from '../model/validate-password-form';
import styles from './password-change-form.module.scss';
import { IChangePassword } from 'shared/api/sso/interfaces/sso.interfaces';
import { passwordChange } from 'features/password-change/model/password-change';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { useParams } from 'react-router-dom';

export const PasswordChangeForm: React.FC = observer(() => {
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [validationError, setValidationError] = useState<string>('');
  const navigate = useNavigate();
  const { key, mail } = useParams();

  const handleSubmit = async () => {
    const errors = validatePasswordChangeForm(password, confirmPassword);
    if (!errors) {
      try {
        if (!key || !mail) {
          throw new Error('Change password key is missing in URL');
        }

        const dto: IChangePassword = {
          password: password,
          changePasswordKey: key,
          email: mail,
        };

        await passwordChange(dto).then(() => {
          navigate(AppLinks.OwnerProfileLink);
        });
      } catch (error) {
        console.error(error);
        setValidationError(String(error));
      }
    } else {
      setValidationError(errors);
    }
  };

  return (
    <div className={styles.password_edit}>
      <div className={styles.password_edit__content}>
        <div className={styles.password_edit__title}>Смена пароля</div>
        <div className={styles.password_edit__inputs}>
          <div className={styles.inputs__input}>
            <FormInput
              inputType="password"
              showPasswordToggle
              inputTitle="Новый пароль"
              inputPlaceholder="Новый пароль"
              onChange={(value) => {
                setPassword(value);
              }}
            />
            <div className={styles.inputs__password_hint}>
              от 8 до 16 символов
            </div>
          </div>
        </div>
        <div className={styles.password_edit__inputs}>
          <div className={styles.inputs__input}>
            <FormInput
              inputType="password"
              showPasswordToggle
              inputTitle="Повторите пароль"
              inputPlaceholder="Повторите пароль"
              onChange={(value) => {
                setConfirmPassword(value);
              }}
            />
          </div>
        </div>
        <div className={styles.password_edit__buttons}>
          <div className={styles.buttons__error}>{validationError}</div>
          <div className={styles.buttons__button_submit} onClick={handleSubmit}>
            <DefaultButton buttonText="Сохранить новый пароль" color="white" />
          </div>
          <div className={styles.buttons__button_back}>
            <FormButtonBack />
          </div>
        </div>
      </div>
    </div>
  );
});
